import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { ICheckUserNameData, ICheckUserNameVars } from '../types';

export const CHECK_USER_NAME: TypedDocumentNode<ICheckUserNameData, ICheckUserNameVars> = gql`
  query getUserName($userName: String!) {
    checkUserName(userName: $userName)
    duplicateUserName(userName: $userName)
    siteStaffList(userName: $userName)
  }
`;
